module.exports = __webpack_public_path__ + "img/Z81_19.c92111fa.jpg";